<script setup lang="ts">
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import LeafletMap from '@/components/Map/LeafletMap.vue'
import type { Coordinates } from '../../../../types/Coordinates'

type Props = {
    gnss_location: Coordinates
}
defineProps<Props>()
</script>

<template>
    <InformationBaseCard class="full-width" :label="$t('device.detail.informations.localization')">
        <LeafletMap class="full-width" />
    </InformationBaseCard>
</template>
